function loadTranslations(lang) {
    if (lang !== 'en') {
        return {
            ...require(`./${lang}/general.json`),
            ...require(`./${lang}/layout-creator.json`),
            ...require(`./${lang}/login-sign-up.json`),
            ...require(`./${lang}/on-boarding.json`),
            ...require(`./${lang}/publish-and-create.json`),
            ...require(`./${lang}/dashboard.json`),
            ...require(`./${lang}/auth.json`),
            ...require(`./${lang}/design.json`),
            ...require(`./${lang}/content.json`),
            ...require(`./${lang}/menus.json`),
            ...require(`./${lang}/forms.json`),
            ...require(`./${lang}/users-and-profiles.json`),
            ...require(`./${lang}/schedule.json`),
            ...require(`./${lang}/form-reports.json`),
            ...require(`./${lang}/push-notifications.json`),
            ...require(`./${lang}/media-library.json`),
            ...require(`./${lang}/components.json`),
            ...require(`./${lang}/e-commerce.json`)
        }
    } else { }
}

export default loadTranslations